<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form :model="formData" label-width="160px"
               ref="ruleForm"
               class="demo-ruleForm">

        <div v-for="(member,index) in row.member_list ">
          <el-divider>人员信息{{ index + 1 }}</el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="'人员'+(index+1)">
                <div v-show="member.name">{{ member.name + '(' + member.num + ')' }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" v-if="row.shenbaotype.indexOf('caipandengjiwudao')>-1">
              <el-form-item label="裁判等级申报(舞蹈)：" prop="caipan">
                <el-radio-group v-model="member.caipanshenbaowudao">
                  <el-radio :label="item" v-for="item in member.caipandengjiwudaooptions">{{ item }}</el-radio>
                </el-radio-group>
                <div class="form-label-desc">{{'现有等级 '+(member.caipandengjiwudao?member.caipandengjiwudao:'无')}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="row.shenbaotype.indexOf('caipandengjijiqiao')>-1">
              <el-form-item label="裁判等级申报(技巧)：" prop="caipan">
                <el-radio-group v-model="member.caipanshenbaojiqiao">
                  <el-radio :label="item" v-for="item in member.caipandengjijiqiaooptions">{{ item }}</el-radio>
                </el-radio-group>
                <div class="form-label-desc">{{'现有等级 '+(member.caipandengjijiqiao?member.caipandengjijiqiao:'无')}}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" v-if="row.shenbaotype.indexOf('jiaoliandengjiwudao')>-1">
              <el-form-item label="教练等级申报(舞蹈)：" prop="jiaolian">
                <el-radio-group v-model="member.jiaolianshenbaowudao">
                  <el-radio :label="item" v-for="item in member.jiaoliandengjiwudaooptions">{{ item }}</el-radio>
                </el-radio-group>
                <div class="form-label-desc">{{'现有等级 '+(member.jiaoliandengjiwudao?member.jiaoliandengjiwudao:'无')}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="row.shenbaotype.indexOf('jiaoliandengjijiqiaooptions')>-1">
              <el-form-item label="教练等级申报(技巧)：" prop="jiaolian">
                <el-radio-group v-model="member.jiaolianshenbaojiqiao">
                  <el-radio :label="item" v-for="item in member.jiaoliandengjijiqiaooptions">{{ item }}</el-radio>
                </el-radio-group>
                <div class="form-label-desc">{{'现有等级 '+(member.jiaoliandengjijiqiao?member.jiaoliandengjijiqiao:'无')}}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存</el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

    </div>
  </div>
</template>
<style scoped>

</style>
<script>
import Vue from "vue";
import area from "@/utils/area";
import validator from "@/utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import FileUploader from "@/components/picker/FileUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

import SubjectJiaolianPicker from "@/components/picker/SubjectJiaolianPicker.vue";
import YundongyuanPicker from "@/components/picker/YundongyuanPicker.vue";

Vue.use(Cell)
    .use(CellGroup)
    .use(Form)
    .use(Divider)
    .use(Area)
    .use(ActionSheet)
    .use(RadioGroup)
    .use(Radio)
    .use(Icon)
    .use(Toast)
    .use(Popup)
    .use(Picker)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Tag)
    .use(Stepper)
    .use(Field)
    .use(Switch)
    .use(Button)
    .use(Dialog);
export default {
  name: "HuiyiApplyFormStep3",
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      leveloption1: [],
      leveloption2: [],
      leveloption3: [],
      leveloption4: [],
      validator,
      playMusicUrl: "",
      thisMemberIndex: 0,
      thisMemberField: "",
      saveLoading: false,
      showNumTypePicker: false,
      showShenbaoTypePicker: false,
      addShow: false,
      show_share_panel: false,
      numTypeColumns: ["身份证", "护照"],
      showArea: false,
      areaList: {},
      thismember: {},
      copy_text: "cccc",
      areaValue: "",
      submitType: "",
      shenbaoTypeColumns: [],
      row: {
        id: 0,
        member_list: [],
        service_options: [],
        shenbaotype: [],
      },
      formData: {
        name: "",
        num: "",
        cardtype: 1,
        numTypeName: "身份证",
      },
    };
  },

  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.row.id = this.$route.query.id;
    document.title = '信息补充';
    if (that.row.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    },
  },
  computed: {
    //            shenbaoTypeColumns(){
    //                return [];
    /*
                 this.row.service_options.map(item =>{
                 return item.name;
                 })
                 */
    //            }
  },
  destroyed() {
  },
  methods: {
    checkselect1() {
      if (this.row.member_list[0].jiaolianshenbaojiqiao != "") {
        this.row.member_list[0].jiaolianshenbaojiqiao = "";
      }
    },
    checkselect2() {
      if (this.row.member_list[0].jiaolianshenbaowudao != "") {
        this.row.member_list[0].jiaolianshenbaowudao = "";
      }
    },
    checkselect3() {
      if (this.row.member_list[0].caipanshenbaojiqiao != "") {
        this.row.member_list[0].caipanshenbaojiqiao = "";
      }
    },
    checkselect4() {
      if (this.row.member_list[0].caipanshenbaowudao != "") {
        this.row.member_list[0].caipanshenbaowudao = "";
      }
    },
    optiontran1() {
      var i = 0;
      for (
          i = 0;
          i < this.row.member_list[0].jiaoliandengjiwudaooptions.length;
          i++
      ) {
        this.leveloption1.push({
          value: this.row.member_list[0].jiaoliandengjiwudaooptions[i],
          label: this.row.member_list[0].jiaoliandengjiwudaooptions[i],
        });
      }
    },
    optiontran2() {
      var i = 0;
      for (
          i = 0;
          i < this.row.member_list[0].jiaoliandengjijiqiaooptions.length;
          i++
      ) {
        this.leveloption2.push({
          value: this.row.member_list[0].jiaoliandengjijiqiaooptions[i],
          label: this.row.member_list[0].jiaoliandengjijiqiaooptions[i],
        });
      }
    },
    optiontran3() {
      var i = 0;
      for (
          i = 0;
          i < this.row.member_list[0].caipandengjiwudaooptions.length;
          i++
      ) {
        this.leveloption3.push({
          value: this.row.member_list[0].caipandengjiwudaooptions[i],
          label: this.row.member_list[0].caipandengjiwudaooptions[i],
        });
      }
    },
    optiontran4() {
      var i = 0;
      for (
          i = 0;
          i < this.row.member_list[0].caipandengjijiqiaooptions.length;
          i++
      ) {
        this.leveloption4.push({
          value: this.row.member_list[0].caipandengjijiqiaooptions[i],
          label: this.row.member_list[0].caipandengjijiqiaooptions[i],
        });
      }
    },
    onQuestion() {
      console.log("onQuestion");
    },
    onShenbaoTypeConfirm(value, index) {
      this.row.member_list[this.thisMemberIndex][this.thisMemberField] = value;
      console.log(this.thisMemberField);
      if (this.thisMemberField == "caipanshenbaowudao") {
        if (this.row.member_list[this.thisMemberIndex]["caipanshenbaojiqiao"]) {
          Toast("裁判舞蹈、技巧只能同时申报一项");
        }
        this.row.member_list[this.thisMemberIndex]["caipanshenbaojiqiao"] = "";
      } else if (this.thisMemberField == "caipanshenbaojiqiao") {
        if (this.row.member_list[this.thisMemberIndex]["caipanshenbaowudao"]) {
          Toast("裁判舞蹈、技巧只能同时申报一项");
        }
        this.row.member_list[this.thisMemberIndex]["caipanshenbaowudao"] = "";
      } else if (this.thisMemberField == "jiaolianshenbaowudao") {
        if (
            this.row.member_list[this.thisMemberIndex]["jiaolianshenbaojiqiao"]
        ) {
          Toast("教练舞蹈、技巧只能同时申报一项");
        }
        this.row.member_list[this.thisMemberIndex]["jiaolianshenbaojiqiao"] =
            "";
      } else if (this.thisMemberField == "jiaolianshenbaojiqiao") {
        if (
            this.row.member_list[this.thisMemberIndex]["jiaolianshenbaowudao"]
        ) {
          Toast("教练舞蹈、技巧只能同时申报一项");
        }
        this.row.member_list[this.thisMemberIndex]["jiaolianshenbaowudao"] = "";
      }
    },

    submitForm(formName) {

      let that = this;
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData)
          that.formValidate = true;
          let valiOk = true;
          if (!valiOk) {
            return;
          }

          that.saveLoading = true;


          that.$api.post(
              "/api/huiyi/shenbaosave",
              {
                baoming_id: that.row.id,
                member_list: that.row.member_list.map((item) => {
                  return {
                    id: item.id || 0,
                    caipandengjiwudao: item.caipandengjiwudao,
                    caipandengjijiqiao: item.caipandengjijiqiao,
                    jiaoliandengjiwudao: item.jiaoliandengjiwudao,
                    jiaoliandengjijiqiao: item.jiaoliandengjijiqiao,

                    caipanshenbaowudao: item.caipanshenbaowudao,
                    caipanshenbaojiqiao: item.caipanshenbaojiqiao,
                    jiaolianshenbaowudao: item.jiaolianshenbaowudao,
                    jiaolianshenbaojiqiao: item.jiaolianshenbaojiqiao,
                  };
                }),
              },
              (res) => {
                appEvent({
                  name: "saiApplyDetailReload",
                  query: {},
                });

                setTimeout(function () {
                  rbLink({
                    name: "HuiyiApplyFormStep5",
                    query: {
                      id: that.row.id,
                    },
                  });
                }, 50);
                that.saveLoading = false;
              },
              (res) => {
                that.$message.warning(res.msg);
                that.saveLoading = false;
              }
          );

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    onSubmit(values) {
      console.log("onSubmit-values", values);
      console.log("submitType", this.submitType);

      let that = this;
      console.log(that.formData);
      that.formValidate = true;
      let valiOk = true;

      if (!valiOk) {
        return;
      }
      that.saveLoading = true;

      that.$api.post(
          "/api/huiyi/shenbaosave",
          {
            baoming_id: that.row.id,
            member_list: that.row.member_list.map((item) => {
              return {
                id: item.id || 0,
                caipandengjiwudao: item.caipandengjiwudao,
                caipandengjijiqiao: item.caipandengjijiqiao,
                jiaoliandengjiwudao: item.jiaoliandengjiwudao,
                jiaoliandengjijiqiao: item.jiaoliandengjijiqiao,

                caipanshenbaowudao: item.caipanshenbaowudao,
                caipanshenbaojiqiao: item.caipanshenbaojiqiao,
                jiaolianshenbaowudao: item.jiaolianshenbaowudao,
                jiaolianshenbaojiqiao: item.jiaolianshenbaojiqiao,
              };
            }),
          },
          (res) => {
            appEvent({
              name: "saiApplyDetailReload",
              query: {},
            });

            setTimeout(function () {
              rbLink({
                name: "HuiyiApplyFormStep5",
                query: {
                  id: that.row.id,
                },
              });
            }, 50);
            that.saveLoading = false;
          },
          (res) => {
            Toast.fail(res.msg);
            that.saveLoading = false;
          }
      );
    },
    save(values) {
      this.submitType = "save";
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    submit(values) {
      this.submitType = "submit";
    },
    fetch() {
      let that = this;
      that.$api.post(
          "/api/huiyi/step3detail",
          {
            id: that.row.id,
          },
          (res) => {
            that.row = res.data;
            that.row.member_list.map((item) => {
            });
            this.optiontran1();
            this.optiontran2();
            this.optiontran3();
            this.optiontran4();
          },
          (res) => {
            Toast.fail(res.msg);
          }
      );
    },

    shareWeixinFriend() {
      console.log("shareWeixinFriend");
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: "shareWeixinFriend",
          query: that.row.share_data,
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: "shareWeixinTimeLine",
          query: that.row.share_data,
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStep3.vue?a3152096